class VideoAutoplay {
  constructor(element) {
    this.element = element
    this.sourceUpdated = false;
    this.handleInsersection = this.handleInsersection.bind(this)

    this.intersectionObserver = new IntersectionObserver(this.handleInsersection)
  }

  handleInsersection([{ isIntersecting }]) {
    if (isIntersecting && !this.sourceUpdated) {
      this.sourceUpdated = true;
      this.element.src = this.element.dataset.videoSrc
    }
  }

  init() {
    this.intersectionObserver.observe(this.element);
  }
}

export default VideoAutoplay;
